import { Image as VuetifyImage } from "tiptap-vuetify";
import ResizableImageNode from "./ResizableImageNode";

/**
 * Same toolbar / upload dialog as tiptap-vuetify Image, but with a TipTap node
 * that supports width attributes and a resizable node view.
 */
export default class ResizableImageExtension extends VuetifyImage {
  constructor(options = {}) {
    super(options);
    this.nativeExtensionInstance = new ResizableImageNode(options);
  }
}
